export const AVAILABLE = 'AVAILABLE';
export const AWAY = 'AWAY';
export const BUSY = 'BUSY';
export const INACTIVE = 'INACTIVE';
export const UNKNOWN = 'UNKNOWN';